import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { ELECTRONIC_SIGNATURE_CONSENT_LABEL } from '../../utilities/electronicSignatureConsent'
import { isAgreementHtmlEmpty, sanitizeAgreementHtml } from '../../utilities/sanitizeHtml'
import styles from './index.module.scss'

export default function PreviewDocument ({
  previewContent,
  isClientFetching,
  clientId
}) {
  const safePreviewContent = useMemo(
    () => sanitizeAgreementHtml(previewContent),
    [previewContent]
  )
  const hasContent = !isAgreementHtmlEmpty(safePreviewContent)

  return (
    <>
      <h3 className={styles.docTitle}>
        Terms &amp; Conditions
      </h3>
      {!isClientFetching &&
        hasContent && (
          <div
            className={cn(
              styles.content,
              'dis-mk-wrapper'
            )}
            dangerouslySetInnerHTML={{
              __html: safePreviewContent
            }}
          />
      )}

      {!isClientFetching &&
        !hasContent && (
          <p className={styles.emptyContent}>No agreement content to preview.</p>
      )}

      {isClientFetching && clientId && (
        <p className={styles.emptyContent} aria-live='polite'>Loading account information...</p>
      )}
      <div className={styles.signatureSection} aria-hidden='true'>
        <div className={styles.fullNameRow}>
          <span className={styles.fullNameLabel}>Full Name</span>
          <input type='text' className={styles.fullNameInput} readOnly tabIndex={-1} />
        </div>
        <div className={styles.agreeRow}>
          <input type='checkbox' className={styles.agreeCheckbox} disabled tabIndex={-1} />
          <span className={styles.agreeLabel}>
            {ELECTRONIC_SIGNATURE_CONSENT_LABEL}
          </span>
        </div>
        <button type='button' className={cn(styles.submitBtn, 'dis-btn dis-btn-primary')} tabIndex={-1}>
          SUBMIT
          <i className='material-icons dis-btn-icon'>check</i>
        </button>
      </div>
    </>
  )
}

PreviewDocument.propTypes = {
  previewContent: PropTypes.string,
  isClientFetching: PropTypes.bool,
  clientId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

PreviewDocument.defaultProps = {
  previewContent: '',
  isClientFetching: false,
  clientId: null
}
